import React, { useEffect } from 'react';
import './styles/normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/styles.css';

import Routes from './routes';

const App = () => {

  useEffect(() => {
    setOrigin();
  }, []);

  const setOrigin = () => {
    const originApp = localStorage.getItem('origin') === 'app' ? true : false;
    const body = document.querySelector('body');
    body.classList.add(originApp ? 'origin-app' : 'origin-browser');
  }

  return (
    <Routes />
  )
};

export default App;
